export const environment = {
    env: 'dev',
    clientId: '22516d4e-db9b-425c-8a2d-16c2111805d8',
    tenantId: '428f4e2e-13bf-4884-b364-02ef9af41a1d',
    objectId: '8efc9984-267b-4d69-8bd4-803acbfe26a8',
    backEndUrl: 'https://filialesexterior-int-dev.apps.ambientesbc.com/auditoria-virtual',
    frontEndUrl: 'https://auditoria-virtual-cfm-dev.apps.ambientesbc.com'
};
